import React from 'react'

import {
  RecordingProvider,
  useRecordingState,
  useRecordingBootstrap,
  useRecordingData
} from './hooks'
import Header from '../Classroom/components/Header'
import { Classroom as ClassroomConstants } from '../../constants'
import Main from './components/Main'
import Controls from './components/Controls'
import { ClassroomEnvProvider, useClassroomEnv } from '../ClassroomEnv'
import { useTracking } from './hooks/useTracking'
import { useHideIntercomLauncher } from '@components/Classroom/hooks/useHideIntercomLauncher'
import { useAuth } from '@hooks'
import { Loader, Text } from '../UI'

const Recording = ({ recording }) => {
  const { env } = useClassroomEnv()
  const { profile } = useAuth()

  const { step, panels } = useRecordingState()
  useRecordingBootstrap({
    classroomId: recording.classroom.id,
    media: recording.media,
    updates: recording.events,
    profile,
    env
  })
  useTracking()
  useHideIntercomLauncher(step)

  return (
    <div className='gp-new-classroom gp-Recording-player'>
      <Header step={step} />

      {step === ClassroomConstants.STEPS.READY && <Main panels={panels} />}

      {step === ClassroomConstants.STEPS.READY && <Controls />}
    </div>
  )
}

const RecordingDataDependencyWrapper = () => {
  const { recording, classroom, ready } = useRecordingData()

  if (!ready)
    return (
      <div className='gp-new-classroom'>
        <Loader full icon style={{ flexDirection: 'column' }}>
          <Text className='text-c' style={{ marginTop: '12px', opacity: 0.9 }}>
            Loading the recording...
          </Text>
        </Loader>
      </div>
    )

  return (
    <ClassroomEnvProvider
      env={ClassroomConstants.ENV.RECORDING}
      id={classroom.id}
    >
      <Recording recording={recording} />
    </ClassroomEnvProvider>
  )
}

const RecordingProvidersWrapper = () => {
  return (
    <RecordingProvider>
      <RecordingDataDependencyWrapper />
    </RecordingProvider>
  )
}

export default RecordingProvidersWrapper
